import React, { useState, useEffect } from 'react';
import OutputType from './ComponentsTpes/OutputType';

const EmergencyOpen = ({ selectedType, fieldsData, componentSourceOptions, selectedPorts, setSelectedPorts,
    savedData, setSavedData
}) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Emergency_open: {
                    ...prevData.Emergency_open,
                    [key]: value
                }
            }
        })
    }

    return <OutputType
        selectedPorts={selectedPorts}
        setSelectedPorts={setSelectedPorts}
        source={componentSourceOptions.outputsData}
        selectOptions={selectOptions}
        component_source={savedData.Emergency_open.component_source.value}
        condition={savedData.Emergency_open.condition}
        output={savedData.Emergency_open.output}
        // selectedType={savedData.Emergency_open.selectedType}
        name={savedData.Emergency_open.name}
        relay_mode={savedData.Emergency_open.relay_mode}
        impulse_time={savedData.Emergency_open.impulse_time}
        entry_exit_open_durations={savedData.Emergency_open.entry_exit_open_durations}
        sensorAutolock={savedData.Emergency_open.sensorAutolock}
        fieldsData={fieldsData}
    />
}

export default EmergencyOpen;